/* global localStorage */

import {
  put,
  call,
  takeLatest,
  takeEvery } from 'redux-saga/effects';
import {
  USER_LOGIN_REQUEST,
  USER_LOGOUT,
  USER_REGISTER_INTEREST,
  USER_SEND_FEEDBACK
} from './constants';
import {
  loginFail,
  loginSuccess,
  logoutSuccess,
  registerInterestSuccess,
  registerInterestFail,
  sendFeedbackSuccess,
  sendFeedbackFail
} from './actions';
import UserAPI from './UserAPI';
import { decodeJWT } from '../util/jwt';
import { parseApiError } from '../util/api';
import { showNotification } from '../notifications/actions';
import { fetchUser } from '../admin/userAdmin/actions';
import { fetchOrg } from '../admin/orgAdmin/actions';

function * login (action) {
  try {
    const { data } = yield call(UserAPI.login, action.user, action.password);
    localStorage.setItem('jwt', data.jwt);
    if (data.lastLogin) localStorage.setItem('lastLogin', data.lastLogin);
    const decoded = decodeJWT(data.jwt);
    yield put(loginSuccess(decoded, data.lastLogin));
    if (action.next && action.history) {
      if (action.next === '/login') {
        action.history.push('/');
      } else {
        action.history.push(action.next);
      }
    }
    if (action.actionOnSuccess) action.actionOnSuccess();
    yield put(fetchUser(decoded.userId));
    if (decoded.orgs && decoded.orgs.length > 0) {
      yield put(fetchOrg(decoded.orgs[0]));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(loginFail(msg));
    yield put(showNotification(
      'Login Failed', msg, 'error', 10
    ));
  }
}

function * logout () {
  localStorage.removeItem('jwt');
  yield put(logoutSuccess());
}

function *registerInterest (action) {
  try {
    let { data } = yield call(
      UserAPI.registerInterest,
      action.cow.id,
      action.cow.name,
      action.phone,
      action.email,
      action.message
    );
    if (data.logged) {
      yield put(registerInterestSuccess());
    } else {
      yield put(registerInterestFail('failed to log enquiry'));
    }
  } catch (error) {
    yield put(registerInterestFail(error.toString()));
  }
}

function *sendFeedback (action) {
  try {
    yield call(
      UserAPI.sendFeedback,
      action.message,
      action.email
    );
    yield put(sendFeedbackSuccess());
  } catch (error) {
    yield put(sendFeedbackFail(error.toString()));
    yield put(showNotification(
      'Sending Failed', error.toString(), 'error', 10
    ));
  }
}

function * userSagas () {
  yield takeLatest(USER_LOGIN_REQUEST, login);
  yield takeEvery(USER_LOGOUT, logout);
  yield takeEvery(USER_REGISTER_INTEREST, registerInterest);
  yield takeEvery(USER_SEND_FEEDBACK, sendFeedback);
}

export default userSagas;
